import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Lightweight SPA SEO head manager (no react-helmet dependency).
 * Keeps document.title, <meta name="description"> and <link rel="canonical">
 * in sync as the user navigates between routes.
 */
export function useSeoHead({ title, description } = {}) {
  const location = useLocation();
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement('meta');
        m.setAttribute('name', 'description');
        document.head.appendChild(m);
      }
      m.setAttribute('content', description);
    }

    const href = window.location.origin + location.pathname;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);
  }, [title, description, location.pathname]);
}

export default useSeoHead;
